/*
 * @Author: Src
 * @Date: 2025-10-14 17:09:35
 * @LastEditTime: 2025-10-14 21:03:17
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/voucher.service.ts
 * @Description: 头部注释配置模板
 */
import { inject, injectable } from 'inversify';
import HttpClient from './http.service';


@injectable()
export default class VoucherService {
  @inject(HttpClient)
  protected http!: HttpClient;

  async getDyhOrderVoucherList(params: any) {
    try {
      const res = await this.http.get('/dyh-order/voucher/list', { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getDyhOrderVoucherDetail(params: any) {
    try {
      const res = await this.http.get('/dyh-order/voucher/detail', { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async getDyhOrderVoucherOrderList(params: any) {
    try {
      const res = await this.http.get('/dyh-order/voucher/order/list', { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async postDyhOrderVoucherAddReceiptVoucher(data: any) {
    try {
      const res = await this.http.post('/dyh-order/voucher/add/receipt-voucher', data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  async postDyhOrderVoucherEditReceiptVoucher(data: any) {
    try {
      const res = await this.http.post('/dyh-order/voucher/edit/receipt-voucher', data) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 删除凭证接口
   */
  async deleteDyhOrderVoucherDeleteReceiptVoucher(params: any) {
    try {
      const res = await this.http.delete('/dyh-order/voucher/delete/receipt-voucher', { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }
}
